const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard', sales: 'Sales', store: 'Store', accounting: 'Accounting',
    suppliersCustomers: 'Suppliers & Customers', settings: 'Settings',
    pos: 'POS', salesReport: 'Sales Report', salesInventory: 'Sales Inventory', cashReport: 'Cash Report',
    itemDetails: 'Item Details', grn: 'GRN', siv: 'SIV', inventory: 'Stock Card', binCard: 'Bin Card', stockAdjustment: 'Stock Adjustment',
    cashReceipt: 'Cash Receipt - CR', paymentVoucher: 'Payment Voucher - PV', cashBook: 'Cash Book', accountPayables: 'Account Payables',
    suppliers: 'Suppliers', customers: 'Customers', profile: 'Profile', users: 'Users',
    logout: 'Logout', online: 'Online', search: 'Search...',
    // Common
    save: 'Save', cancel: 'Cancel', newEntry: 'New', edit: 'Edit', delete: 'Delete',
    date: 'Date', notes: 'Notes', status: 'Status', actions: 'Actions', total: 'Total',
    active: 'Active', inactive: 'Inactive', name: 'Name', email: 'Email', phone: 'Phone',
    address: 'Address', role: 'Role', type: 'Type', amount: 'Amount', quantity: 'Quantity',
    product: 'Product', supplier: 'Supplier', customer: 'Customer', description: 'Description',
    reference: 'Reference', balance: 'Balance', paid: 'Paid', pending: 'Pending', completed: 'Completed',
    loading: 'Loading...', saving: 'Saving...', noData: 'No data found.',
    // Pages
    dashboardTitle: 'Dashboard', posTitle: 'Point of Sale',
    salesReportTitle: 'Sales Report', salesInventoryTitle: 'Sales Inventory',
    cashReportTitle: 'Cash Report', itemDetailsTitle: 'Item Details',
    grnTitle: 'Goods Received Note (GRN)', sivTitle: 'Store Issue Voucher (SIV)',
    inventoryTitle: 'Stock Card', binCardTitle: 'Bin Card', stockAdjustmentTitle: 'Stock Adjustment',
    cashReceiptTitle: 'Cash Receipt', paymentVoucherTitle: 'Payment Voucher',
    cashBookTitle: 'Cash Book', accountPayablesTitle: 'Account Payables',
    suppliersTitle: 'Suppliers', customersTitle: 'Customers',
    profileTitle: 'Profile', usersTitle: 'User Management',
    // GRN
    newGRN: 'New GRN', totalGRNs: 'Total GRNs', thisMonth: 'This Month',
    // SIV
    newSIV: 'New SIV', totalSIVs: 'Total SIVs', department: 'Department',
    // Stock Adjustment
    newAdjustment: 'New Adjustment', increase: 'Increase', decrease: 'Decrease',
    reason: 'Reason', storeBalance: 'Store balance', newStockWillBe: 'New stock will be',
    saveAdjustment: 'Save Adjustment',
    // Users
    userManagement: 'User Management', manageUsers: 'Manage system users and permissions',
    addUser: 'Add User', searchUsers: 'Search users...',
    // Settings
    businessSettings: 'Business Settings', updateProfile: 'Update Profile',
  },

  am: {
    // Navigation
    dashboard: 'ዳሽቦርድ', sales: 'ሽያጭ', store: 'መጋዘን', accounting: 'ሂሳብ',
    suppliersCustomers: 'አቅራቢዎች እና ደንበኞች', settings: 'ቅንብሮች',
    pos: 'የሽያጭ ነጥብ', salesReport: 'የሽያጭ ሪፖርት', salesInventory: 'የሽያጭ ክምችት', cashReport: 'የጥሬ ገንዘብ ሪፖርት',
    itemDetails: 'የምርት ዝርዝር', grn: 'የዕቃ መቀበያ', siv: 'የዕቃ ማስወጫ', inventory: 'Stock Card', binCard: 'Bin Card', stockAdjustment: 'የክምችት ማስተካከያ',
    cashReceipt: 'የጥሬ ገንዘብ 영수증 - CR', paymentVoucher: 'የክፍያ ቫውቸር - PV', cashBook: 'የጥሬ ገንዘብ መዝገብ', accountPayables: 'የሂሳብ ዕዳ',
    suppliers: 'አቅራቢዎች', customers: 'ደንበኞች', profile: 'መገለጫ', users: 'ተጠቃሚዎች',
    logout: 'ውጣ', online: 'ተያይዟል', search: 'ፈልግ...',
    // Common
    save: 'አስቀምጥ', cancel: 'ሰርዝ', newEntry: 'አዲስ', edit: 'አርትዕ', delete: 'ሰርዝ',
    date: 'ቀን', notes: 'ማስታወሻ', status: 'ሁኔታ', actions: 'ድርጊቶች', total: 'ጠቅላላ',
    active: 'ንቁ', inactive: 'ቦዘነ', name: 'ስም', email: 'ኢሜይል', phone: 'ስልክ',
    address: 'አድራሻ', role: 'ሚና', type: 'አይነት', amount: 'መጠን', quantity: 'ብዛት',
    product: 'ምርት', supplier: 'አቅራቢ', customer: 'ደንበኛ', description: 'መግለጫ',
    reference: 'ማጣቀሻ', balance: 'ቀሪ ሂሳብ', paid: 'ተከፍሏል', pending: 'በመጠባበቅ ላይ', completed: 'ተጠናቋል',
    loading: 'በመጫን ላይ...', saving: 'በማስቀመጥ ላይ...', noData: 'ምንም ዳታ አልተገኘም።',
    // Pages
    dashboardTitle: 'ዳሽቦርድ', posTitle: 'የሽያጭ ነጥብ',
    salesReportTitle: 'የሽያጭ ሪፖርት', salesInventoryTitle: 'የሽያጭ ክምችት',
    cashReportTitle: 'የጥሬ ገንዘብ ሪፖርት', itemDetailsTitle: 'የምርት ዝርዝር',
    grnTitle: 'የዕቃ መቀበያ ማስታወሻ', sivTitle: 'የዕቃ ማስወጫ ቫውቸር',
    inventoryTitle: 'Stock Card', binCardTitle: 'Bin Card', stockAdjustmentTitle: 'የክምችት ማስተካከያ',
    cashReceiptTitle: 'የጥሬ ገንዘብ 영수증', paymentVoucherTitle: 'የክፍያ ቫውቸር',
    cashBookTitle: 'የጥሬ ገንዘብ መዝገብ', accountPayablesTitle: 'የሂሳብ ዕዳ',
    suppliersTitle: 'አቅራቢዎች', customersTitle: 'ደንበኞች',
    profileTitle: 'መገለጫ', usersTitle: 'የተጠቃሚ አስተዳደር',
    // GRN
    newGRN: 'አዲስ GRN', totalGRNs: 'ጠቅላላ GRNs', thisMonth: 'በዚህ ወር',
    // SIV
    newSIV: 'አዲስ SIV', totalSIVs: 'ጠቅላላ SIVs', department: 'ክፍል',
    // Stock Adjustment
    newAdjustment: 'አዲስ ማስተካከያ', increase: 'ጨምር', decrease: 'ቀንስ',
    reason: 'ምክንያት', storeBalance: 'የመጋዘን ቀሪ', newStockWillBe: 'አዲሱ ክምችት ይሆናል',
    saveAdjustment: 'ማስተካከያ አስቀምጥ',
    // Users
    userManagement: 'የተጠቃሚ አስተዳደር', manageUsers: 'ስርዓቱ ተጠቃሚዎችን እና ፈቃዶችን ያስተዳድሩ',
    addUser: 'ተጠቃሚ ጨምር', searchUsers: 'ተጠቃሚዎችን ፈልግ...',
    // Settings
    businessSettings: 'የንግድ ቅንብሮች', updateProfile: 'መገለጫ አዘምን',
  },

  fr: {
    // Navigation
    dashboard: 'Tableau de bord', sales: 'Ventes', store: 'Magasin', accounting: 'Comptabilité',
    suppliersCustomers: 'Fournisseurs & Clients', settings: 'Paramètres',
    pos: 'Point de vente', salesReport: 'Rapport de vente', salesInventory: 'Inventaire des ventes', cashReport: 'Rapport de caisse',
    itemDetails: 'Détails article', grn: 'Bon de réception', siv: 'Bon de sortie', inventory: 'Fiche de Stock', binCard: 'Fiche de Casier', stockAdjustment: 'Ajustement de stock',
    cashReceipt: 'Reçu de caisse - CR', paymentVoucher: 'Bon de paiement - PV', cashBook: 'Livre de caisse', accountPayables: 'Comptes fournisseurs',
    suppliers: 'Fournisseurs', customers: 'Clients', profile: 'Profil', users: 'Utilisateurs',
    logout: 'Déconnexion', online: 'En ligne', search: 'Rechercher...',
    // Common
    save: 'Enregistrer', cancel: 'Annuler', newEntry: 'Nouveau', edit: 'Modifier', delete: 'Supprimer',
    date: 'Date', notes: 'Notes', status: 'Statut', actions: 'Actions', total: 'Total',
    active: 'Actif', inactive: 'Inactif', name: 'Nom', email: 'E-mail', phone: 'Téléphone',
    address: 'Adresse', role: 'Rôle', type: 'Type', amount: 'Montant', quantity: 'Quantité',
    product: 'Produit', supplier: 'Fournisseur', customer: 'Client', description: 'Description',
    reference: 'Référence', balance: 'Solde', paid: 'Payé', pending: 'En attente', completed: 'Terminé',
    loading: 'Chargement...', saving: 'Enregistrement...', noData: 'Aucune donnée trouvée.',
    // Pages
    dashboardTitle: 'Tableau de bord', posTitle: 'Point de vente',
    salesReportTitle: 'Rapport de vente', salesInventoryTitle: 'Inventaire des ventes',
    cashReportTitle: 'Rapport de caisse', itemDetailsTitle: 'Détails article',
    grnTitle: 'Bon de réception (BRC)', sivTitle: 'Bon de sortie (BS)',
    inventoryTitle: 'Fiche de Stock', binCardTitle: 'Fiche de Casier', stockAdjustmentTitle: 'Ajustement de stock',
    cashReceiptTitle: 'Reçu de caisse', paymentVoucherTitle: 'Bon de paiement',
    cashBookTitle: 'Livre de caisse', accountPayablesTitle: 'Comptes fournisseurs',
    suppliersTitle: 'Fournisseurs', customersTitle: 'Clients',
    profileTitle: 'Profil', usersTitle: 'Gestion des utilisateurs',
    // GRN
    newGRN: 'Nouveau BRC', totalGRNs: 'Total BRC', thisMonth: 'Ce mois',
    // SIV
    newSIV: 'Nouveau BS', totalSIVs: 'Total BS', department: 'Département',
    // Stock Adjustment
    newAdjustment: 'Nouvel ajustement', increase: 'Augmenter', decrease: 'Diminuer',
    reason: 'Raison', storeBalance: 'Stock magasin', newStockWillBe: 'Le nouveau stock sera',
    saveAdjustment: 'Enregistrer l\'ajustement',
    // Users
    userManagement: 'Gestion des utilisateurs', manageUsers: 'Gérer les utilisateurs et les permissions',
    addUser: 'Ajouter utilisateur', searchUsers: 'Rechercher utilisateurs...',
    // Settings
    businessSettings: 'Paramètres entreprise', updateProfile: 'Mettre à jour le profil',
  },

  ar: {
    // Navigation
    dashboard: 'لوحة التحكم', sales: 'المبيعات', store: 'المخزن', accounting: 'المحاسبة',
    suppliersCustomers: 'الموردون والعملاء', settings: 'الإعدادات',
    pos: 'نقطة البيع', salesReport: 'تقرير المبيعات', salesInventory: 'مخزون المبيعات', cashReport: 'تقرير النقدية',
    itemDetails: 'تفاصيل المنتج', grn: 'إيصال استلام', siv: 'قسيمة صرف', inventory: 'بطاقة المخزون', binCard: 'بطاقة الصنف', stockAdjustment: 'تسوية المخزون',
    cashReceipt: 'إيصال نقدي - CR', paymentVoucher: 'قسيمة دفع - PV', cashBook: 'دفتر النقدية', accountPayables: 'الذمم الدائنة',
    suppliers: 'الموردون', customers: 'العملاء', profile: 'الملف الشخصي', users: 'المستخدمون',
    logout: 'تسجيل الخروج', online: 'متصل', search: 'بحث...',
    // Common
    save: 'حفظ', cancel: 'إلغاء', newEntry: 'جديد', edit: 'تعديل', delete: 'حذف',
    date: 'التاريخ', notes: 'ملاحظات', status: 'الحالة', actions: 'الإجراءات', total: 'الإجمالي',
    active: 'نشط', inactive: 'غير نشط', name: 'الاسم', email: 'البريد الإلكتروني', phone: 'الهاتف',
    address: 'العنوان', role: 'الدور', type: 'النوع', amount: 'المبلغ', quantity: 'الكمية',
    product: 'المنتج', supplier: 'المورد', customer: 'العميل', description: 'الوصف',
    reference: 'المرجع', balance: 'الرصيد', paid: 'مدفوع', pending: 'معلق', completed: 'مكتمل',
    loading: 'جار التحميل...', saving: 'جار الحفظ...', noData: 'لا توجد بيانات.',
    // Pages
    dashboardTitle: 'لوحة التحكم', posTitle: 'نقطة البيع',
    salesReportTitle: 'تقرير المبيعات', salesInventoryTitle: 'مخزون المبيعات',
    cashReportTitle: 'تقرير النقدية', itemDetailsTitle: 'تفاصيل المنتج',
    grnTitle: 'إيصال استلام البضائع', sivTitle: 'قسيمة صرف المخزن',
    inventoryTitle: 'بطاقة المخزون', binCardTitle: 'بطاقة الصنف', stockAdjustmentTitle: 'تسوية المخزون',
    cashReceiptTitle: 'إيصال نقدي', paymentVoucherTitle: 'قسيمة دفع',
    cashBookTitle: 'دفتر النقدية', accountPayablesTitle: 'الذمم الدائنة',
    suppliersTitle: 'الموردون', customersTitle: 'العملاء',
    profileTitle: 'الملف الشخصي', usersTitle: 'إدارة المستخدمين',
    // GRN
    newGRN: 'إيصال جديد', totalGRNs: 'إجمالي الإيصالات', thisMonth: 'هذا الشهر',
    // SIV
    newSIV: 'قسيمة جديدة', totalSIVs: 'إجمالي القسائم', department: 'القسم',
    // Stock Adjustment
    newAdjustment: 'تسوية جديدة', increase: 'زيادة', decrease: 'نقصان',
    reason: 'السبب', storeBalance: 'رصيد المخزن', newStockWillBe: 'المخزون الجديد سيكون',
    saveAdjustment: 'حفظ التسوية',
    // Users
    userManagement: 'إدارة المستخدمين', manageUsers: 'إدارة مستخدمي النظام والصلاحيات',
    addUser: 'إضافة مستخدم', searchUsers: 'البحث عن مستخدمين...',
    // Settings
    businessSettings: 'إعدادات الأعمال', updateProfile: 'تحديث الملف الشخصي',
  },

  ti: {
    // Navigation
    dashboard: 'ዳሽቦርድ', sales: 'ሽያጥ', store: 'ዕቃ ቤት', accounting: 'ሕሳብ',
    suppliersCustomers: 'ዋሓዝቲ & ዓማዊል', settings: 'ምቕናዕ',
    pos: 'ናይ ሽያጥ ነጥቢ', salesReport: 'ጸብጻብ ሽያጥ', salesInventory: 'ክምችት ሽያጥ', cashReport: 'ጸብጻብ ናቕፋ',
    itemDetails: 'ዝርዝር ኣቑሑ', grn: 'ደረሰኝ ምቕባል', siv: 'ቮቸር ምዝርጋሕ', inventory: 'Stock Card', binCard: 'Bin Card', stockAdjustment: 'ምስተኻኽላ ክምችት',
    cashReceipt: 'ደረሰኝ ናቕፋ - CR', paymentVoucher: 'ቮቸር ክፍሊት - PV', cashBook: 'መጽሓፍ ናቕፋ', accountPayables: 'ዕዳ ክፍሊት',
    suppliers: 'ዋሓዝቲ', customers: 'ዓማዊል', profile: 'ፕሮፋይል', users: 'ተጠቀምቲ',
    logout: 'ውጻእ', online: 'ኦንላይን', search: 'ድለ...',
    // Common
    save: 'ኣቐምጥ', cancel: 'ሰርዝ', newEntry: 'ሓዲሽ', edit: 'ኣርትዕ', delete: 'ሰርዝ',
    date: 'ዕለት', notes: 'መዝገብ', status: 'ኩነታት', actions: 'ተግባራት', total: 'ድምር',
    active: 'ንጡፍ', inactive: 'ዘይንጡፍ', name: 'ስም', email: 'ኢሜይል', phone: 'ቴሌፎን',
    address: 'ኣድራሻ', role: 'ሚና', type: 'ዓይነት', amount: 'መጠን', quantity: 'ብዝሒ',
    product: 'ፍርያት', supplier: 'ዋሓዚ', customer: 'ዓሚል', description: 'መግለጺ',
    reference: 'ማጣቀሲ', balance: 'ሚዛን', paid: 'ተኸፊሉ', pending: 'ተጸቢዩ', completed: 'ተዛዚሙ',
    loading: 'ይጽዓን...', saving: 'ይቐምጥ...', noData: 'ዝርከብ ሓበሬታ የለን።',
    // Pages
    dashboardTitle: 'ዳሽቦርድ', posTitle: 'ናይ ሽያጥ ነጥቢ',
    salesReportTitle: 'ጸብጻብ ሽያጥ', salesInventoryTitle: 'ክምችት ሽያጥ',
    cashReportTitle: 'ጸብጻብ ናቕፋ', itemDetailsTitle: 'ዝርዝር ኣቑሑ',
    grnTitle: 'ናይ ምቕባል ደረሰኝ (GRN)', sivTitle: 'ቮቸር ምዝርጋሕ ዕቃ (SIV)',
    inventoryTitle: 'Stock Card', binCardTitle: 'Bin Card', stockAdjustmentTitle: 'ምስተኻኽላ ክምችት',
    cashReceiptTitle: 'ደረሰኝ ናቕፋ', paymentVoucherTitle: 'ቮቸር ክፍሊት',
    cashBookTitle: 'መጽሓፍ ናቕፋ', accountPayablesTitle: 'ዕዳ ክፍሊት',
    suppliersTitle: 'ዋሓዝቲ', customersTitle: 'ዓማዊል',
    profileTitle: 'ፕሮፋይል', usersTitle: 'ምሕደራ ተጠቀምቲ',
    // GRN
    newGRN: 'ሓዲሽ GRN', totalGRNs: 'ድምር GRNs', thisMonth: 'እዚ ወርሒ',
    // SIV
    newSIV: 'ሓዲሽ SIV', totalSIVs: 'ድምር SIVs', department: 'ክፍሊ',
    // Stock Adjustment
    newAdjustment: 'ሓዲሽ ምስተኻኽላ', increase: 'ወስኽ', decrease: 'ኣጉድል',
    reason: 'ምኽንያት', storeBalance: 'ሚዛን ዕቃ ቤት', newStockWillBe: 'ሓዲሽ ክምችት ክኸውን',
    saveAdjustment: 'ምስተኻኽላ ኣቐምጥ',
    // Users
    userManagement: 'ምሕደራ ተጠቀምቲ', manageUsers: 'ተጠቀምቲ ስርዓትን ፍቓዳትን ኣቐናበሩ',
    addUser: 'ተጠቃሚ ወስኽ', searchUsers: 'ተጠቀምቲ ድለ...',
    // Settings
    businessSettings: 'ምቕናዕ ንግዲ', updateProfile: 'ፕሮፋይል ኣሐድስ',
  },

  sw: {
    // Navigation
    dashboard: 'Dashibodi', sales: 'Mauzo', store: 'Ghala', accounting: 'Uhasibu',
    suppliersCustomers: 'Wasambazaji & Wateja', settings: 'Mipangilio',
    pos: 'Mauzo ya Moja kwa Moja', salesReport: 'Ripoti ya Mauzo', salesInventory: 'Hesabu ya Mauzo', cashReport: 'Ripoti ya Pesa',
    itemDetails: 'Maelezo ya Bidhaa', grn: 'Hati ya Kupokelea', siv: 'Hati ya Kutoa', inventory: 'Kadi ya Hisa', binCard: 'Kadi ya Ghala', stockAdjustment: 'Marekebisho ya Hisa',
    cashReceipt: 'Risiti ya Pesa - CR', paymentVoucher: 'Vocha ya Malipo - PV', cashBook: 'Kitabu cha Pesa', accountPayables: 'Madeni ya Kulipa',
    suppliers: 'Wasambazaji', customers: 'Wateja', profile: 'Wasifu', users: 'Watumiaji',
    logout: 'Toka', online: 'Mtandaoni', search: 'Tafuta...',
    // Common
    save: 'Hifadhi', cancel: 'Ghairi', newEntry: 'Mpya', edit: 'Hariri', delete: 'Futa',
    date: 'Tarehe', notes: 'Maelezo', status: 'Hali', actions: 'Vitendo', total: 'Jumla',
    active: 'Amilifu', inactive: 'Siyo Amilifu', name: 'Jina', email: 'Barua pepe', phone: 'Simu',
    address: 'Anwani', role: 'Jukumu', type: 'Aina', amount: 'Kiasi', quantity: 'Idadi',
    product: 'Bidhaa', supplier: 'Msambazaji', customer: 'Mteja', description: 'Maelezo',
    reference: 'Kumbukumbu', balance: 'Salio', paid: 'Imelipwa', pending: 'Inasubiri', completed: 'Imekamilika',
    loading: 'Inapakia...', saving: 'Inahifadhi...', noData: 'Hakuna data iliyopatikana.',
    // Pages
    dashboardTitle: 'Dashibodi', posTitle: 'Mauzo ya Moja kwa Moja',
    salesReportTitle: 'Ripoti ya Mauzo', salesInventoryTitle: 'Hesabu ya Mauzo',
    cashReportTitle: 'Ripoti ya Pesa', itemDetailsTitle: 'Maelezo ya Bidhaa',
    grnTitle: 'Hati ya Kupokelea Bidhaa', sivTitle: 'Hati ya Kutoa Bidhaa',
    inventoryTitle: 'Kadi ya Hisa', binCardTitle: 'Kadi ya Ghala', stockAdjustmentTitle: 'Marekebisho ya Hisa',
    cashReceiptTitle: 'Risiti ya Pesa', paymentVoucherTitle: 'Vocha ya Malipo',
    cashBookTitle: 'Kitabu cha Pesa', accountPayablesTitle: 'Madeni ya Kulipa',
    suppliersTitle: 'Wasambazaji', customersTitle: 'Wateja',
    profileTitle: 'Wasifu', usersTitle: 'Usimamizi wa Watumiaji',
    // GRN
    newGRN: 'Hati Mpya', totalGRNs: 'Jumla ya Hati', thisMonth: 'Mwezi Huu',
    // SIV
    newSIV: 'Hati Mpya ya Kutoa', totalSIVs: 'Jumla ya Hati za Kutoa', department: 'Idara',
    // Stock Adjustment
    newAdjustment: 'Marekebisho Mapya', increase: 'Ongeza', decrease: 'Punguza',
    reason: 'Sababu', storeBalance: 'Salio la Ghala', newStockWillBe: 'Hisa mpya itakuwa',
    saveAdjustment: 'Hifadhi Marekebisho',
    // Users
    userManagement: 'Usimamizi wa Watumiaji', manageUsers: 'Simamia watumiaji na ruhusa za mfumo',
    addUser: 'Ongeza Mtumiaji', searchUsers: 'Tafuta watumiaji...',
    // Settings
    businessSettings: 'Mipangilio ya Biashara', updateProfile: 'Sasisha Wasifu',
  },
};

export default translations;
